module.exports = __webpack_public_path__ + "img/kin8.d96665e5.jpg";